import { navigateIndex, formatCounter } from '../utils/wizard_helpers'

export default class CarouselController {
  constructor(element) {
    this.element = element
    this.images = element.querySelectorAll('[data-carousel-image]')
    this.counter = element.querySelector('[data-carousel-counter]')
    this.currentIndex = 0
    this.total = this.images.length

    this.bindEvents()
    this.showImage(0)
  }

  bindEvents() {
    const prevBtn = this.element.querySelector('[data-carousel-prev]')
    const nextBtn = this.element.querySelector('[data-carousel-next]')

    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.prev() })
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.next() })

    // Click on image opens modal
    this.images.forEach((img) => {
      img.style.cursor = 'pointer'
      img.addEventListener('click', () => this.openModal())
    })
  }

  showImage(index) {
    this.images.forEach((img, i) => {
      img.style.display = i === index ? 'block' : 'none'
    })
    if (this.counter) {
      this.counter.textContent = formatCounter(index, this.total)
    }
  }

  next() {
    this.currentIndex = navigateIndex(this.currentIndex, 1, this.total)
    this.showImage(this.currentIndex)
    if (this.modalOpen) this.updateModalImage()
  }

  prev() {
    this.currentIndex = navigateIndex(this.currentIndex, -1, this.total)
    this.showImage(this.currentIndex)
    if (this.modalOpen) this.updateModalImage()
  }

  openModal() {
    this.modalOpen = true
    const imageSrcs = Array.from(this.images).map(img => img.src)

    // Create modal
    this.modal = document.createElement('div')
    this.modal.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.9);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    `

    // Close button
    const closeBtn = document.createElement('button')
    closeBtn.innerHTML = `<svg style="width: 32px; height: 32px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>`
    closeBtn.style.cssText = `
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      padding: 8px;
    `
    closeBtn.addEventListener('click', () => this.closeModal())

    // Image container
    this.modalImageContainer = document.createElement('div')
    this.modalImageContainer.style.cssText = `
      max-width: 90vw;
      max-height: 85vh;
      display: flex;
      align-items: center;
      justify-content: center;
    `

    // Modal image
    this.modalImage = document.createElement('img')
    this.modalImage.style.cssText = `
      max-width: 100%;
      max-height: 85vh;
      object-fit: contain;
    `
    this.modalImageContainer.appendChild(this.modalImage)

    // Counter
    this.modalCounter = document.createElement('div')
    this.modalCounter.style.cssText = `
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      color: white;
      font-size: 16px;
      background: rgba(0, 0, 0, 0.5);
      padding: 8px 16px;
      border-radius: 20px;
    `

    // Navigation arrows (only if multiple images)
    if (this.total > 1) {
      const prevBtn = document.createElement('button')
      prevBtn.innerHTML = `<svg style="width: 32px; height: 32px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>`
      prevBtn.style.cssText = `
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        cursor: pointer;
        padding: 16px;
        border-radius: 50%;
      `
      prevBtn.addEventListener('click', () => this.prev())

      const nextBtn = document.createElement('button')
      nextBtn.innerHTML = `<svg style="width: 32px; height: 32px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>`
      nextBtn.style.cssText = `
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        cursor: pointer;
        padding: 16px;
        border-radius: 50%;
      `
      nextBtn.addEventListener('click', () => this.next())

      this.modal.appendChild(prevBtn)
      this.modal.appendChild(nextBtn)
    }

    this.modal.appendChild(closeBtn)
    this.modal.appendChild(this.modalImageContainer)
    this.modal.appendChild(this.modalCounter)

    // Close on background click
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal()
    })

    // Close on Escape key
    this.escHandler = (e) => {
      if (e.key === 'Escape') this.closeModal()
      if (e.key === 'ArrowLeft') this.prev()
      if (e.key === 'ArrowRight') this.next()
    }
    document.addEventListener('keydown', this.escHandler)

    document.body.appendChild(this.modal)
    document.body.style.overflow = 'hidden'

    this.updateModalImage()
  }

  updateModalImage() {
    const currentImg = this.images[this.currentIndex]
    this.modalImage.src = currentImg.src
    this.modalCounter.textContent = `${this.currentIndex + 1} / ${this.total}`
  }

  closeModal() {
    this.modalOpen = false
    if (this.modal) {
      this.modal.remove()
      this.modal = null
    }
    document.body.style.overflow = ''
    if (this.escHandler) {
      document.removeEventListener('keydown', this.escHandler)
    }
  }
}

// Auto-initialize carousels
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="carousel"]').forEach(el => {
    new CarouselController(el)
  })
})
